/**
 * FormCombobox component for rendering a combobox field with Formik.
 * This includes the label, the select itself and error message.
 *
 * ## Example usage:
 *
 *   ...
 */
import React from 'react'
import { ErrorMessage, Field } from 'formik'
import { Tooltip } from '../Tooltip'
import { Combobox } from '../../components/ui/combobox'

type FormComboboxProps = {
    name: string
    label: string
    placeholder?: string
    options: any[]
    required?: boolean
    tooltip?: string
}

export function FormCombobox({ label, name, tooltip, placeholder, options, required = false, ...props }: FormComboboxProps) {
    return (
        <div className="flex flex-col gap-1.5">
            <div className="flex gap-1 items-center w-full">
                <label htmlFor={name} className="text-grey100 font-sm-bold">
                    {label}
                </label>
                {required ? <span className="text-red20">*</span> : null}
                {tooltip ? <Tooltip>{tooltip}</Tooltip> : null}
            </div>

            <Field name={name}>
                {({ field, form }: any) => (
                    <Combobox
                        name={name}
                        placeholder={placeholder}
                        value={field.value}
                        options={options}
                        onValueChange={(value: string) => {
                            form.setFieldValue(field.name, value)
                        }}
                    />
                )}
            </Field>

            <ErrorMessage name={name} component="span" className="text-sm text-red20" />
        </div>
    )
}
